import { usePaginatedMasterData } from './usePaginatedMasterData';
import { getDesignations } from '../services/designationService';
import type {
  DesignationListFilters,
  DesignationListItem,
} from '../types/designation';
import { activeConfigurationFilters } from '../utils/configurationFilters';

const EMPTY_FILTERS: DesignationListFilters = activeConfigurationFilters();

export function useDesignations() {
  return usePaginatedMasterData<DesignationListItem, DesignationListFilters>({
    getId: item => item.designationId,
    initialFilters: EMPTY_FILTERS,
    errorMessage: 'Unable to load designations.',
    loadPage: async ({ page, pageSize, search, filters }) =>
      getDesignations({
        page,
        pageSize,
        filters: {
          ...filters,
          search: search || undefined,
        },
      }),
  });
}
